import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output, ChangeDetectorRef, NgZone, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsersService, UtilsService, FeedbackCardService, CommunicationService } from 'app/helpers/services';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';

interface Star {
  value: number;
  selected: boolean;
  interactable: boolean;
}

interface Feedback {
  formId: string;
  rating: number;
  goodThings: any;
  badThings: any;
  goodOther: string;
  badOther: string;
}

interface AnimatedEmoji {
  value: number;
  emoji: string;
  animatedEmoji?: string;
  selected: boolean;
  interactable: boolean;
  label: string;
  isAnimating?: boolean;
}

declare var $: any;

@Component({
  selector: 'app-feedback-card',
  templateUrl: './feedback-card.component.html',
  styleUrls: ['./feedback-card.component.scss'],
  providers: [UsersService, UtilsService, FeedbackCardService, CommunicationService],
})

export class FeedbackCardComponent implements OnInit, OnChanges {

  @Input() selectedRating: number;
  @Output() formSubmitted: EventEmitter<any> = new EventEmitter();
  selectedModalRating: number = 0;
  loggedInUser: any;
  userId: any;
  MoodOfTheCrewForm: FormGroup; //formgroup variable
  MoodOfTheCrewForm2: FormGroup; //formgroup variable 

  good: FormArray; //array to store good things
  bad: FormArray; //array to store bad things

  goodThings: any[] = [];
  badThings: any[] = [];
  goodQuestionTitle: string = '';
  badQuestionTitle: string = '';
  showGoodOther: boolean = false;
  showBadOther: boolean = false;
  goodExpanded: boolean = false;
  badExpanded: boolean = false;
  readonly CHIP_LIMIT = 6;

  feedback: Feedback = {
    formId: '',
    rating: 0,
    goodThings: [],
    badThings: [],
    goodOther: '',
    badOther: '',
  };

  stars: Star[] = [
    { value: 1, selected: false, interactable: false },
    { value: 2, selected: false, interactable: false },
    { value: 3, selected: false, interactable: false },
    { value: 4, selected: false, interactable: false },
    { value: 5, selected: false, interactable: false },
  ];

  emojis: AnimatedEmoji[] = [
    { 
      value: 1, 
      emoji: '😞', 
      animatedEmoji: '😢', 
      selected: false, 
      interactable: false, 
      label: 'Bad',
      isAnimating: false 
    },
    { 
      value: 2, 
      emoji: '🙁', 
      animatedEmoji: '😟', 
      selected: false, 
      interactable: false, 
      label: 'Not so good',
      isAnimating: false 
    },
    { 
      value: 3, 
      emoji: '😐', 
      animatedEmoji: '😑', 
      selected: false, 
      interactable: false, 
      label: 'Okay',
      isAnimating: false 
    },
    { 
      value: 4, 
      emoji: '🙂', 
      animatedEmoji: '😊', 
      selected: false, 
      interactable: false, 
      label: 'Good',
      isAnimating: false 
    },
    { 
      value: 5, 
      emoji: '😊', 
      animatedEmoji: '🤩', 
      selected: false, 
      interactable: false, 
      label: 'Excellent',
      isAnimating: false 
    }
  ];

  formId: any;
  delayedShowQuestions = false;
  formSubmittedSuccessfully = false;
  submissionMessage = '';
  isGoodOtherChecked: boolean = false;
  isBadOtherChecked: boolean = false;

  projectList: any[] = [];
  availableProjects: any[] = [];
  selectedProjects: any[] = [];
  projectInput: string = '';
  defaultProject: any = null;
  projectError: boolean = false;
  showProjectDropdown: boolean = false;
  @ViewChild('projectInputEl') projectInputEl: ElementRef;

  //Animation control properties
  private animationTimeouts: { [key: number]: any } = {};
  private pulseAnimationActive = false;
  private pulseInterval: any;
  entranceAnimationDone = false;
  shareIdentity: boolean = false;

  constructor(private http: HttpClient, private feedbackservice: FeedbackCardService, private usersService: UsersService, public utils: UtilsService, private formBuilder: FormBuilder, public communicationService: CommunicationService, private cdr: ChangeDetectorRef,
    private ngZone: NgZone) {
    this.MoodOfTheCrewForm = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
    this.MoodOfTheCrewForm2 = this.formBuilder.group({
      checkArray2: this.formBuilder.array([])
    })
  }

  ngOnInit() {
    // Set the initial selected rating to the input value
    this.selectRating(this.selectedRating);
    this.viewForm();
    this.loadFeedbackOptions();
    this.loggedInUser = this.utils.getLoggedInUser();
    this.userId = this.loggedInUser.id;
    this.loadUserProjects();

    // Set up modal event listeners
    $('#feedbackModal')
        .on('shown.bs.modal', () => {
            // Start animations when modal is shown
            this.startPulseAnimation();
            this.resetEntranceAnimation();

            if (this.selectedModalRating > 0) {
              this.delayedShowQuestions = false;
              setTimeout(() => {
                this.ngZone.run(() => {
                  this.delayedShowQuestions = true;
                  this.cdr.detectChanges();
                });
              }, 600);
            } else {
              this.delayedShowQuestions = false;
            }
        })
        .on('hidden.bs.modal', () => {
            // Clean up when modal is hidden
            this.pulseAnimationActive = false;
            if (this.pulseInterval) {
                clearInterval(this.pulseInterval);
                this.pulseInterval = null;
            }
            this.delayedShowQuestions = false;
        });
  }

  //enabling emojiEntrance animation for a short duration
  resetEntranceAnimation() {
    this.entranceAnimationDone = false;
    setTimeout(() => {
      this.entranceAnimationDone = true;
    }, 600); 
  }

  //to clear all timeouts
  private clearAllTimeouts(): void {
    for (const key in this.animationTimeouts) {
      if (this.animationTimeouts.hasOwnProperty(key)) {
        clearTimeout(this.animationTimeouts[key]);
      }
    }
    this.animationTimeouts = {};
  }

  private startPulseAnimation() {
    this.selectedModalRating = this.selectedRating || 0;
    
    if (this.selectedModalRating === 0 && !this.pulseAnimationActive) {
      this.pulseAnimationActive = true;
      
      const pulseInterval = setInterval(() => {
        if (this.selectedModalRating > 0) {
          clearInterval(pulseInterval);
          this.pulseAnimationActive = false;
          return;
        }
        
        // Randomly select an emoji to pulse
        const randomIndex = Math.floor(Math.random() * this.emojis.length);
        const emoji = this.emojis[randomIndex];
        
        if (!emoji.selected && !emoji.isAnimating) {
          this.triggerEmojiAnimation(emoji, 'pulse');
        }
      }, 2000 + Math.random() * 2000); // Random interval between 2-4 seconds
    }
  }

  //to trigger specific emoji animations
  private triggerEmojiAnimation(emoji: AnimatedEmoji, animationType: 'pulse' | 'bounce' | 'flip') {
    if (emoji.isAnimating) return;
    emoji.isAnimating = true;
    
    // Clear any existing timeout for this emoji
    if (this.animationTimeouts[emoji.value]) {
      clearTimeout(this.animationTimeouts[emoji.value]);
    }
    
    // Set animation timeout
    this.animationTimeouts[emoji.value] = setTimeout(() => {
      emoji.isAnimating = false;
    }, 600); // Animation duration
  }

  //to get current emoji display (animated or static)
  getCurrentEmoji(emoji: AnimatedEmoji): string {
    if (emoji.selected && emoji.animatedEmoji) {
      return emoji.animatedEmoji;
    }
    return emoji.emoji;
  }

  //to get animation classes
  getEmojiAnimationClass(emoji: AnimatedEmoji): string {
    let classes = '';

    if (emoji.isAnimating) {
      classes += 'emoji-selected-bounce ';
    }
    
    if (emoji.isAnimating && !emoji.selected) {
      classes += 'emoji-pulse ';
    }
    
    if (emoji.interactable && !emoji.selected) {
      classes += 'emoji-hover-bounce ';
    }
    
    return classes.trim();
  }

  getLabelColorClass(emojiValue: number): string {
    switch(emojiValue) {
      case 1: return 'label-bad';        
      case 2: return 'label-not-good';   
      case 3: return 'label-okay';       
      case 4: return 'label-good';       
      case 5: return 'label-excellent';  
      default: return '';
    }
  }

  get feedbackTitle(): string {
    const today = new Date();
    const isMonday = today.getDay() === 1; 
    return isMonday ? 'How was your past week?' : 'How was your week?';
  }

  getSubmittedEmojiDisplay(): string {
    const submittedEmoji = this.emojis.find(emoji => emoji.value === this.selectedModalRating);
    return submittedEmoji ? submittedEmoji.animatedEmoji || submittedEmoji.emoji : '😊';
  }

  getSubmittedRatingLabel(): string {
    const submittedEmoji = this.emojis.find(emoji => emoji.value === this.selectedModalRating);
    return submittedEmoji ? submittedEmoji.label : 'Good';
  }
  
  getSubmittedRatingClass(): string {
    switch(this.selectedModalRating) {
      case 1: return 'rating-bad';        
      case 2: return 'rating-not-good';   
      case 3: return 'rating-okay';       
      case 4: return 'rating-good';       
      case 5: return 'rating-excellent';  
      default: return 'rating-good';
    }
  }

  viewForm() {
    this.feedbackservice.viewForms().subscribe((response: any) => {
      if (this.utils.isResponseSuccess(response)) {
        if (response.responseData && response.responseData.length > 0) {
          response.responseData.forEach((item: any) => {
            const responseData = item.responseData;
            if (responseData.title == "Mood of the crew") {
              this.formId = responseData.id;
            }
          });
        }
      }
    });
  }

  loadFeedbackOptions() {
    this.feedbackservice.getDomains().subscribe((domainRes: any) => {
      const domains = domainRes && domainRes.response_data && domainRes.response_data.domains;
      const mocDomain = domains ? domains.find((d: any) => d.domain_key === 'mood_of_the_crew') : null;
      if (!mocDomain) { return; }

      this.feedbackservice.getQuestions(mocDomain.domain_key).subscribe((qRes: any) => {
        const questions = qRes && qRes.response_data && qRes.response_data.questions;
        if (!questions) { return; }

        const multiSelectQuestions = questions
          .filter((q: any) => q.question_type === 'multi_select' && q.is_active)
          .sort((a: any, b: any) => a.display_order - b.display_order);

        if (multiSelectQuestions[0]) {
          this.goodQuestionTitle = multiSelectQuestions[0].question_text;
          const goodActiveOptions = multiSelectQuestions[0].options.filter((o: any) => o.is_active);
          this.goodThings = goodActiveOptions
            .filter((o: any) => !o.allows_other_text)
            .map((o: any) => ({ value: o.option_text, label: o.option_text }));
          this.showGoodOther = goodActiveOptions.some((o: any) => o.allows_other_text);
        }
        if (multiSelectQuestions[1]) {
          this.badQuestionTitle = multiSelectQuestions[1].question_text;
          const badActiveOptions = multiSelectQuestions[1].options.filter((o: any) => o.is_active);
          this.badThings = badActiveOptions
            .filter((o: any) => !o.allows_other_text)
            .map((o: any) => ({ value: o.option_text, label: o.option_text }));
          this.showBadOther = badActiveOptions.some((o: any) => o.allows_other_text);
        }
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const currentValue = changes.selectedRating.currentValue;
    this.selectModalRating(currentValue);
  }

  onStarClick(star: Star) {
    this.selectModalRating(star.value);
  }

  onEmojiClick(emoji: AnimatedEmoji) {
    //Prevent clicking the same emoji again
    if (this.selectedModalRating === emoji.value) {
      return;
    }
    this.pulseAnimationActive = false;
    this.clearAllTimeouts();
    this.delayedShowQuestions = true;

    //Reset all emoji states
    this.emojis.forEach(e => {
      e.isAnimating = false;
      e.interactable = false;
      e.selected = false;
    });
    
    //set the selected emoji and update rating
    emoji.selected = true;
    this.selectedModalRating = emoji.value;
    this.selectedRating = emoji.value;
    this.feedback.rating = emoji.value;

    // Auto-check identity sharing for the two lowest ratings
    if (emoji.value <= 2) {
      this.shareIdentity = true;
    } else {
      this.shareIdentity = false;
    }

    // Trigger animation ONLY for the newly selected emoji
    this.triggerEmojiAnimation(emoji, 'bounce');
  }

  onGoodOtherToggle(checked: boolean) {
    this.isGoodOtherChecked = checked;
    if (!this.isGoodOtherChecked) {
      this.feedback.goodOther = '';
    }
  }
  
  onBadOtherToggle(checked: boolean) {
    this.isBadOtherChecked = checked;
    if (!this.isBadOtherChecked) {
      this.feedback.badOther = '';
    }
  }

  // modal rating selection with animations
  selectModalRating(rating: number) {
    this.selectedModalRating = rating;
    this.feedback.rating = rating;
    
    this.emojis.forEach(emoji => {
      const wasSelected = emoji.selected;
      emoji.selected = emoji.value == rating;
      
      //Trigger animation for newly selected emoji
      if (!wasSelected && emoji.selected) {
        this.triggerEmojiAnimation(emoji, 'bounce');
      }
    });
  }

  selectRating(rating: number) {
    // Update the selected rating
    this.selectedRating = rating;
  }

  //function to bind input to feedback object
  onCheckboxChange(e: any, formGroup: FormGroup, formArrayName: string) {
    const formArray = formGroup.get(formArrayName) as FormArray;
    if (!e.target.classList.contains('active')) {
      formArray.push(new FormControl(e.target.querySelector('input').value));
    } else {
      let i: number = 0;
      formArray.controls.forEach((item: FormControl) => {
        if (item.value == e.target.querySelector('input').value) {
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
    return formArray;
  }

  //function to call binding depending on field 'What went good?'
  onCheckboxChangeGood(e: any) {
    this.onCheckboxChange(e, this.MoodOfTheCrewForm, 'checkArray');
    this.good = this.MoodOfTheCrewForm.get('checkArray').value as FormArray;
  }
  //function to call binding depending on field 'What could have been better?'
  onCheckboxChangeBad(e: any) {
    this.onCheckboxChange(e, this.MoodOfTheCrewForm2, 'checkArray2');
    this.bad = this.MoodOfTheCrewForm2.get('checkArray2').value as FormArray;
  }

  skipFeedback() {
    $('#feedbackModal').modal('hide');
    // Reset form state
    this.formSubmittedSuccessfully = false;
    this.selectedRating = 0;
    this.selectedModalRating = 0;
    this.delayedShowQuestions = false;
    this.MoodOfTheCrewForm.reset();
    this.MoodOfTheCrewForm2.reset();
    this.isGoodOtherChecked = false;
    this.isBadOtherChecked = false;
    this.feedback.goodOther = '';
    this.feedback.badOther = '';
    this.shareIdentity = false;
    this.good = new FormArray([]).value;
    this.bad = new FormArray([]).value;
    this.goodExpanded = false;
    this.badExpanded = false;
    this.projectInput = '';
    this.showProjectDropdown = false;
    this.applyDefaultProject();
    // // Reset emoji states
    this.emojis.forEach(emoji => {
      emoji.selected = false;
      emoji.interactable = false;
      emoji.isAnimating = false;
    });
    if (this.formSubmittedSuccessfully) {
      this.formSubmitted.emit();
    }
  }

  //final submit button function and binding
  submitForm() {
    this.feedback.rating = this.selectedRating;
    this.feedback.goodThings = (this.good && Array.isArray(this.good) ? this.good : []).filter(v => v != null);
    this.feedback.badThings = (this.bad && Array.isArray(this.bad) ? this.bad : []).filter(v => v != null);

    this.submitMoodOfTheCrew();//to submit the feedback

    if (this.selectedModalRating <= 2) {
      this.submissionMessage = "Tough weeks happen — hope things turn around soon!";
    } else if (this.selectedModalRating === 3) {
      this.submissionMessage = "Steady progress — looking forward to an even better week!";
    } else {
      this.submissionMessage = "Glad you had a great week! Let's keep it up!";
    }
    this.formSubmittedSuccessfully = true;
  }

  closeModal() {
    $('#feedbackModal').modal('hide');
    this.formSubmitted.emit();
    
    //Clean up animations
    this.pulseAnimationActive = false;
    if (this.pulseInterval) {
      clearInterval(this.pulseInterval);
    }
    this.clearAllTimeouts();
    
    // Reset form state
    this.formSubmittedSuccessfully = false;
    this.selectedRating = 0;
    this.selectedModalRating = 0;
    this.delayedShowQuestions = false;
    this.shareIdentity = false;
    this.goodExpanded = false;
    this.badExpanded = false;
    this.MoodOfTheCrewForm.reset();
    this.MoodOfTheCrewForm2.reset();
    this.projectInput = '';
    this.showProjectDropdown = false;
    this.applyDefaultProject();

    // Reset emoji states
    this.emojis.forEach(emoji => {
      emoji.selected = false;
      emoji.interactable = false;
      emoji.isAnimating = false;
    });
  }

  submitMoodOfTheCrew() {
    //bind the input to request body
    const formResponse: any = {
      userId: this.userId,
      rating: this.feedback.rating,
      whatWentGood: this.feedback.goodThings,
      whatWentBad: this.feedback.badThings,
      goodOthers: this.feedback.goodOther,
      badOthers: this.feedback.badOther,
      shareIdentity: this.shareIdentity,
      projects: this.selectedProjects.map(p => ({ projectId: p.projectId, projectName: p.name }))
    }
    if (this.shareIdentity) {
      formResponse.userName = this.loggedInUser.firstName + ' ' + (this.loggedInUser.lastName || '');
      formResponse.userEmail = this.loggedInUser.email;
    }
    const req = {
      formId: this.formId,
      userId: this.userId,
      feedbackResponse: formResponse
    }
    this.feedbackservice.moodOfTheCrewFeedback(req).subscribe((result: any) => {
      if (this.utils.isResponseSuccess(result) && result.responseData) {
      } else {
        if (result.statusCode === 306) {
          this.utils.applogout()
        }
      }
    })
  }

  loadUserProjects() {
    this.usersService.getAllProjectWorkedPerUser({ userId: this.userId }).subscribe((response: any) => {
      if (response && response.responseData) {
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

        this.projectList = response.responseData
          .filter((p: any) => p.active)
          .map((p: any) => ({
            projectId: p.projectId,
            name: p.projectName,
            lastReportedDate: p.lastReportedDate,
          }))
          .filter((p: any) => p.lastReportedDate && new Date(p.lastReportedDate) >= thirtyDaysAgo);

        const withDates = this.projectList.filter(p => p.lastReportedDate);
        if (withDates.length > 0) {
          const latestDate = withDates.reduce((max, p) =>
            p.lastReportedDate > max ? p.lastReportedDate : max, withDates[0].lastReportedDate);
          const latestGroup = withDates.filter(p => p.lastReportedDate === latestDate);
          this.defaultProject = latestGroup[Math.floor(Math.random() * latestGroup.length)];
        }

        this.applyDefaultProject();
      }
    });
  }

  applyDefaultProject() {
    this.availableProjects = this.projectList.map(p => ({ ...p }));
    if (this.defaultProject) {
      this.selectedProjects = [{ ...this.defaultProject }];
      this.availableProjects = this.availableProjects.filter(p => p.projectId !== this.defaultProject.projectId);
    } else {
      this.selectedProjects = [];
    }
  }

  onProjectSelected(event: any) {
    if (event && event.name) {
      if (!this.selectedProjects) {
        this.selectedProjects = [];
      }
      this.selectedProjects.push(event);
      this.projectError = false;
      for (let i = 0; i < this.availableProjects.length; i++) {
        if (this.availableProjects[i].name === event.name) {
          this.availableProjects.splice(i, 1);
          break;
        }
      }
      setTimeout(() => {
        this.projectInput = '';
        if (this.projectInputEl) {
          this.projectInputEl.nativeElement.value = '';
        }
      }, 100);
    }
  }

  onProjectRemoved(event: any) {
    const removed = event.value;
    this.availableProjects.push(removed);
    if (this.selectedProjects.length === 0) {
      this.projectError = true;
    }
  }

  removeProjectChip(proj: any) {
    this.selectedProjects = this.selectedProjects.filter(p => p.projectId !== proj.projectId);
    this.availableProjects.push(proj);
    this.projectError = this.selectedProjects.length === 0;
  }

  toggleProjectDropdown() {
    this.showProjectDropdown = !this.showProjectDropdown;
  }

  onProjectSelectChange(event: any) {
    const projectId = event.target.value;
    const proj = this.availableProjects.find(p => p.projectId == projectId);
    if (proj) {
      this.selectedProjects.push(proj);
      this.availableProjects = this.availableProjects.filter(p => p.projectId !== proj.projectId);
      this.projectError = false;
    }
    this.showProjectDropdown = false;
    event.target.value = '';
  }

  ngOnDestroy() {
    // Clean up event listeners
    $('#feedbackModal').off('shown.bs.modal hidden.bs.modal');

    // Clean up animations
    this.pulseAnimationActive = false;
    if (this.pulseInterval) {
      clearInterval(this.pulseInterval);
    }
    this.clearAllTimeouts();
  }
}

